'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import Hooks from '@benzinga/hooks';
import { ScannerConfigManager, ScannerConfigManagerEvent, ScannerConfig } from '@benzinga/scanner-config-manager';

export const useScannerConfigs = (): ScannerConfig[] | undefined => {
  const session = React.useContext(SessionContext);
  const scannerConfigManager = session.getManager(ScannerConfigManager);

  const [configs, setConfigs] = React.useState(scannerConfigManager.getConfigs());

  Hooks.useSubscriber(scannerConfigManager, (event: ScannerConfigManagerEvent) => {
    switch (event.type) {
      case 'scanner:updated_scanners':
        setConfigs(event.scanners);
        break;
    }
  });

  React.useEffect(() => {
    scannerConfigManager.fetchConfigs();
  }, [scannerConfigManager]);

  return configs;
};
